import { render } from "./Generalpersonal.vue?vue&type=template&id=814c1362"
import script from "./Generalpersonal.vue?vue&type=script&lang=js"
export * from "./Generalpersonal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__